import PropTypes from 'prop-types';

export const ruleEditorViewPartCommonProps = {
    id: PropTypes.string,
    partClassification: PropTypes.string,
    placeholder: PropTypes.string,
    predicateType: PropTypes.string,
    type: PropTypes.string,
    plainrender: PropTypes.bool
};
